import type { ReactNode } from 'react';

function BottomFooter({ children }: { children: ReactNode }) {
  return (
    <div className="bg-white fixed bottom-0 left-0 right-0 p-4 shadow-[0_-2px_8px_rgba(0,0,0,0.08)] max-w-[752px] mx-auto w-full md:left-[unset] md:right-[unset] md:rounded-t-lg">
      {children}
    </div>
  );
}

export default BottomFooter;
